import selectTemplate from './select.tpl.html';

export class Select {
  constructor($scope, $translate, $http) {
    Object.assign(this, {
      $scope,
      $translate,
      $http,
    });
  }

  $onInit() {
    this.items = [];
    this.labelKey = this.labelKey || 'name';
    this.idKey = this.idKey || 'id';
  }
  refreshItems(str) {
    const params = Object.assign({}, { name: str }, this.serviceFnParams || {});
    return this.servicefn(params)
      .then((res) => {
        this.items = res.data.data.items || res.data.data;
      });
  }

  onSelect(item, model) {
    this.modelChange({ item, model, binding: this.onChangeBinding });
  }

  shouldBeTopPositioned() {
    return this.position === 'top';
  }
}

Select.$inject = [
  '$scope',
  '$translate',
  '$http',
];

export const select = {
  template: selectTemplate,
  controller: Select,
  restrict: 'E',
  bindings: {
    model: '=',
    humanReadable: '@',
    servicefn: '<',
    serviceFnParams: '<?',
    modelChange: '&',
    onChangeBinding: '=?',
    labelKey: '@',
    idKey: '@?',
    placeholder: '@',
    required: '<?',
    name: '@',
    position: '@?',
  },
};
